export default {
  data () {
    return {
      classNotSorted: 'bx bx-down-arrow-alt icon-sort-disabled', // todo icon sort
      classSortDesc: 'bx bx-down-arrow-alt highlight-sort',
      classNotAsc: 'bx bx-up-arrow-alt highlight-sort',
    };
  },
  methods: {
    updateUrlFilters () {
      const customQuery = this.customQuery || {};
      const filterQuery = {};
      Object.keys(this.filters).forEach((key) => {
        if (this.filters[key] !== null && this.filters[key] !== undefined) {
          filterQuery[key] = this.filters[key].toString();
        } else {
          filterQuery[key] = null;
        }
      });
      this.$router.push({
        name: this.$route.name,
        query: { ...filterQuery, searchToken: this.getSearchToken(), ...customQuery },
      });
    },
    clickSort (column) {
      if (column !== this.filters.column) {
        this.filters.column = column;
        this.filters.dir = 'DESC';
        this.updateUrlFilters();
        return;
      }

      this.filters.dir = (this.filters.dir === 'ASC') ? 'DESC' : 'ASC';
      this.updateUrlFilters();
    },
    getSortClass (column) {
      if (this.filters.column !== column) return this.classNotSorted;

      return this.filters.dir === 'DESC' ? this.classSortDesc : this.classNotAsc;
    },
    getSearchToken() {
      // generate the timestamp and 3 random number
      const ts = String(new Date().getTime());
      const rand = String(Math.floor(Math.random() * 1000));
      return ts + rand;
    },
    getHeaderClass(item) {
      let classes = [];
      if (item.sortable) {
        classes.push('col-sortable');
      }
      if (item.width) {
        classes.push(`cell-${item.width}`);
      }
      if (item.additionalClasses) {
        classes.push(item.additionalClasses);
      }

      return classes;
    },
    updateFiltersWithoutSearch(initQueries = {}) {
      for (const key in this.filters) {
        if (!['column', 'dir', 'page', 'searchToken'].includes(key)) {
          this.filters[key] = this.$route.query[key] || "";

          if (initQueries.hasOwnProperty(key) && initQueries[key]) {
            this.filters[key] = initQueries[key];
          }
        }
      }
    }
  },
  computed: {
    queryUrl() {
      return this.$route.query
    }
  },
};
